const store = {
  localStorageKey: process.env.VUE_APP_LOCALSTORAGE_KEY,
  loading: false,
  data: {
    user: {},
    userInfos: null
  },
  modal: {
    active: false,
    childVue: '',
    dataModel: {},
    size: ''
  },
  fileviewer: {
    active: false,
    image: null
  },
  banner: {
    active: false,
    type: '',
    message: ''
  },
  api: {
    auth: process.env.VUE_APP_API_AUTH,
    base: process.env.VUE_APP_API_BASE
  },
  order: {
    id: 0
  }
}

export default store
